import PrimaryButtonComponent from "@/app/components/ui/Buttons/PrimaryButtonComponent";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { IOnlineToOffline, usePaymentOnlineToOfflineAPI } from "@/app/hooks/api_hooks/payment/usePaymentOnlineToOfflineAPI";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import React, { Fragment, useRef } from "react";
import { useForm } from "react-hook-form";
type Props = {
  open: boolean;
  isOfflinePaymentEnabled: boolean;
  setOpen: (value: boolean) => void;
  setIsOfflinePaymentEnabled: (value: boolean) => void;
  addOfflinePaymentMethod: (ff: any) => void;
  offlineData: any
};

const SwitchOnlineToOfflineConfirmationModal: React.FC<Props> = ({
  open,
  setOpen,
  isOfflinePaymentEnabled,
  setIsOfflinePaymentEnabled,
  addOfflinePaymentMethod,
  offlineData
}) => {
  const cancelButtonRef = useRef(null);
  const { execute: sendAlertForOfflineCollection } = usePaymentOnlineToOfflineAPI()
  const { mappedClinicId } = useAppSelector((state) => state.root.UIStates);
  const offlineDataItem = useSelectMenuReducer(offlineData, "offline_reason", "offline_reason");

  


  const formHook = useForm<any>({
    mode: "onChange",
    defaultValues: {
      reason: null
    },
  });

  const handelClick = () => {

    const paylod: IOnlineToOffline = {
      reason: formHook.watch(`reason`),
      clinic_id: mappedClinicId
    }
    sendAlertForOfflineCollection(paylod).then(({ status }) => {
      if (status) {
        addOfflinePaymentMethod({ payments_method: null, amount: "0" })
        setIsOfflinePaymentEnabled(true);
        setOpen(false);
      } else {
        setOpen(false);
      }
    })

  };

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => {
            setOpen(false);
          }}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom p-4 bg-white rounded-lg text-left  overflow-visible  shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:max-w-2xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 rounded-lg">
                  <div className="flex justify-between items-center ">
                    <h2 className="text-sm font-semibold">Are you sure you want to switch to offline payment collection methods?</h2>
                    <XMarkIcon className="w-6 h-6 font-bold cursor-pointer" onClick={() => setOpen(false)} />
                  </div>

                  <div className="w-80 pt-6">
                    <SearchableSelectMenu
                      errorMessages={[{ message: "Category is required", type: "required" }]}
                      onSelectItem={(item) => {
                        if (item) {
                          formHook.setValue(`reason`, item.id);
                        }
                      }}
                      fieldError={formHook?.formState?.errors?.cities}
                      register={formHook.register(`reason`, { required: true })}
                      selectItems={offlineDataItem}
                      placeholder="Select reason"
                      showTooltips={true}
                      showTypedErrors={false}
                      showDropdownIcon={true}
                      defaultSelected={offlineDataItem?.filter((oc) => oc.id === formHook.watch(`reason`))[0]}
                      listBoxClassName="w-full"
                      className="text-gray-800 w-full"
                      containerClassName="w-full"
                    />
                  </div>
                  <div className="flex justify-end mt-10">
                    <PrimaryButtonComponent
                      onClickPrimaryButton={handelClick}
                      primaryButtonText="Switch to Offline Payment"
                      primaryClassName=" text-xs bg-black hover:bg-gray-600 text-white font-semibold py-3 px-10 rounded focus:outline-none focus:shadow-outline"
                      seconderyClassName=" text-xs bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-3 px-10 rounded focus:outline-none focus:shadow-outline"
                      seconderyButtonText="Cancel"
                      onClickSeconderyButton={() => {
                        setIsOfflinePaymentEnabled(false);
                        setOpen(false);
                      }}
                      variant="primary"
                      showPrimaryButton={true}
                      showSeconderyButton={true}
                      primarrybuttonDisable={formHook.watch("reason") ? false : true}
                    />
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default SwitchOnlineToOfflineConfirmationModal;
